<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "ProductBrandComponent",
};
</script>

<style scoped></style>
